<div>
  @if ((loading$$.asObservable() | async) === false) {
    @if (!data?.locked) {
      @if (config?.RequiresAccount && (!data?.account?.connectionId || data?.account?.tokenBroken)) {
        <button
          data-action="connect-social-service"
          class="sidebar-button"
          color="primary"
          (click)="connectSocialService()"
          mat-flat-button
        >
          {{ syncButtonText() }}
        </button>
      }

      @if (data?.account?.connectionId && !data?.account?.isAuthenticated) {
        <glxy-alert type="warning" actionTitle="{{ 'COMMON.RECONNECT_ACCOUNT' | translate }}">
          {{ 'GOOGLE_INSIGHTS.SOCIAL_TOKEN_BROKEN' | translate }}
          <br /><br />
          <button mat-stroked-button class="action-color" (click)="connectSocialService()">
            {{ 'COMMON.RECONNECT_ACCOUNT' | translate }}
          </button>
        </glxy-alert>
      } @else if (data?.sourceId === GoogleSourceID && data?.account?.isAuthenticated && !data?.account?.isVerified) {
        <glxy-alert type="warning">
          <strong>{{ 'GOOGLE_INSIGHTS.NOT_VERIFIED.TITLE' | translate }}</strong>
          &mdash; {{ 'GOOGLE_INSIGHTS.NOT_VERIFIED.DESCRIPTION' | translate }}<br />
          <br />
          <button mat-stroked-button class="action-color">
            <a [href]="gmbVerifyUrl" target="_blank">
              {{ 'GOOGLE_INSIGHTS.NOT_VERIFIED.VERIFY_LINK' | translate }}
            </a>
          </button>
        </glxy-alert>
      } @else if (
        (data?.account?.connectionId || (!config?.RequiresAccount && data?.provider === DirectProvider)) &&
        !data?.isSyncingEnabled
      ) {
        <button
          data-action="turn-on-syncing-for-social-service"
          class="sidebar-button"
          color="primary"
          (click)="updateSyncing(true)"
          mat-flat-button
        >
          {{ syncButtonText() }}
        </button>
      }
    } @else if (requiresLSP(data?.requirement) && data?.locked) {
      <button class="sidebar-button" color="primary" (click)="upgrade.emit()" mat-flat-button>
        {{ 'LISTING_SYNC.SYNCING_STATUS.SYNC_TO' | translate }} {{ data?.name }}
      </button>
    }

    @if (data?.sourceId === AppleSourceID && (appleBusinessConnectFF$ | async)) {
      <platform-integration-connection-button
        [config]="appleBCConnectionButtonConfig"
      ></platform-integration-connection-button>
    }

    @if (
      data?.listingId || data?.account?.connectionId || (data?.provider === DirectProvider && data?.isSyncingEnabled)
    ) {
      <button class="sidebar-button" mat-stroked-button [matMenuTriggerFor]="optionsMenu">More</button>
    }
  } @else {
    <glxy-loading-spinner></glxy-loading-spinner>
  }
</div>

<mat-menu #optionsMenu="matMenu">
  @if (!!data?.listingId) {
    <button class="menu-button" (click)="refreshListing()" mat-menu-item>
      <mat-icon>refresh</mat-icon>
      {{ 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.REFRESH' | translate }}
    </button>
  }
  @if (data?.account?.connectionId) {
    <button class="menu-button" data-action="disconnect-social-service" (click)="disconnectService()" mat-menu-item>
      <mat-icon>link_off</mat-icon>
      {{ 'COMMON.DISCONNECT' | translate }}
    </button>
  }
  @if (data?.provider === DirectProvider && data?.isSyncingEnabled) {
    <button
      class="menu-button"
      data-action="turn-off-syncing-for-social-service"
      (click)="updateSyncing(false)"
      mat-menu-item
    >
      <mat-icon>sync_disabled</mat-icon>
      {{ 'LISTING_SYNC.LSP_ADDON.COLUMNS.SYNC_STATUS.TURN_OFF_SYNCING' | translate }}
    </button>
  }
</mat-menu>
